/*
 * Page navigation
 */

var _taskHistory=[];
var _toneUpTalkHistory=[];

var initialWindowHistoryLength = null;

if ( window.history ) {
    initialWindowHistoryLength = window.history.length;
    console.log('Page Navigation: initial history length ' + initialWindowHistoryLength)
}

function add(Options={}) {
    var options = {
        root:false,
        task:null,
        url:null,
        fragment:false,
        allowOn:[],
        toneUpTalk:false
    };
    $.extend(options,Options);	
    var last=null;

    if (options.toneUpTalk) {
        if (options.root) _toneUpTalkHistory=[]
        var taskHistory=_toneUpTalkHistory;
    } else {
        if (options.root) taskHistory=[]
        var taskHistory=_taskHistory;
    }

    // filter out the language tags
    /*
    const rootUrl = new URL ( otuApp.appState.rootUrl );

    const reg = new RegExp('^' + rootUrl.pathname + '(en/|es/)','g');
    options.url = options.url.replace( reg, rootUrl.pathname );


    if (otuApp.isCordovaApp()) {
        options.url=getHostname(options.url) + options.url;
        console.log('Page Navigation: Cordova Rewritten Url to ' + options.url);
    }
    */


    if (taskHistory.length) {
        last = taskHistory[taskHistory.length-1];

        // if the last task is the same replace it and we are done
        if (last.task==options.task) {
            taskHistory[taskHistory.length-1]=options;
            console.log('Page Navigation: Updating Task ' + options.task);
            setDocTitle(options.task)
            return otuApp.taskHistory;
        }

        // remove the fragments unless we allow to keep them
        taskHistory=taskHistory.filter(e => ((e.fragment && (options.allowOn.includes(e.task) || options.allowOn.includes('*'))) || !e.fragment));

        //  if we already have this task lower down in the stack we remove it
        taskHistory=taskHistory.filter(e => (e.task!=options.task));

    }

    // add the task
    taskHistory.push(options);
    console.log('Page Navigation: Adding Task ' + options.task);

    if (options.toneUpTalk) {
        _toneUpTalkHistory=taskHistory;
    } else {
        _taskHistory=taskHistory;;
    }

    setDocTitle(options.task)

    return otuApp.pageNavigation;
}


function restoreTask(Options={}) {
    var options = {
        toneUpTalk: false
    };
    $.extend(options,Options);	

    console.log('Page Navigation: Restoring Task');

    if (options.toneUpTalk) {
        var taskHistory=_toneUpTalkHistory;
    } else {
        if (messaging.modalOpen) {
            messaging.closeModal();
            return true;
        }
        var taskHistory=_taskHistory;
    }

    // if the menu is open we close it
    if (typeof appMenu!=='undefined') {
        if (!appMenu.hidden) {
            appMenu.hide();
            return true;
        }
    }

    // we background the app if we are in root
    if (otuApp.isCordovaApp() && taskHistory.length===1) {
        return myApp.background();
    } 

    if (    otuApp.appUser.guest &&
            !otuApp.isCordovaApp() && 
            taskHistory.length===1 && 
            initialWindowHistoryLength!==null &&
            taskHistory[taskHistory.length-1].root 
        ) {
        var relStart = window.history.length - initialWindowHistoryLength
        return window.history.go(-relStart);
    } 

    taskHistory.pop();

    if (taskHistory.length) {
        var last = taskHistory[taskHistory.length-1];
        console.log('Page Navigation: Restoring Task ' + last.task, last.url);

        // todo allow for attr options
        if (options.toneUpTalk) {
            otuApp.triggerAjaxGet(last.url,
                {"attr":{"data-keep-animation":true},
                 restoreTask:true
                });	
        } else {
            otuApp.triggerAjaxGet(last.url,{restoreTask:true});
        }
        return otuApp.pageNavigation;
    } else {
        return reset(options);
    }

}

function setDocTitle( task ) {
    document.title=( !otuApp.appUser.guest ? otuApp.appUser.name + ' - ' : '') + task + ' -  Knowledge Island - Operation Tone-Up'; 
}

function reloadLast(Options={}) {

    var taskHistory=_taskHistory;

    if (taskHistory.length) {
        var last = taskHistory[taskHistory.length-1];
        var rootUrl = new URL(otuApp.appState.rootUrl);
        var url = rootUrl.origin + last.url;

        console.log('Page Navigation: Reloading Last Task ' + last.task + ' ' + url);

        otuApp.triggerAjaxGet(url);
    
    }
    
    return otuApp.pageNavigation;
}

function refreshAppState(Options={}) {

    defaultUrl=otuApp.appState.rootUrl  + 'index.php?component=com_otu_op&task=appStateRefresh';
    otuApp.triggerAjaxGet(defaultUrl,
        {"attr":{"data-keep-animation":"true"}});

}

function reset(Options={}) {
    var options = {
        restoreDefaultTask:true,
        toneUpTalk: false
    };
    $.extend(options,Options);

    console.log('Page Navigation: Reset');


    if (options.toneUpTalk) {
        _toneUpTalkHistory=[];
    } else {
        _taskHistory=[];
    }

    if (options.restoreDefaultTask) {
        let defaultUrl=null

        if ( otuApp.appUser.guest ) {

            if ( ( document.referrer.startsWith('https://operationtoneup.com') || otuApp.appState.fundraiserDomain) && window.history ) {
                console.log('Page Navigation: Reset -> automated window.history.back() guest and otu site or fundraiser based.');
                window.history.back()
                return true
            }
        

            defaultUrl=otuApp.appState.rootUrl;
            otuApp.triggerAjaxGet(defaultUrl,
                {"attr":{"data-hide-template-position":"columns-all"}});

        } else {
            if (options.toneUpTalk) {
                defaultUrl=otuApp.appState.rootUrl  + 'index.php?component=com_otu_op&task=messages.refreshDashboard';
                otuApp.triggerAjaxGet(defaultUrl,
                    {"attr":{"data-keep-animation":"true"}});	
            } else {

                if ( document.referrer.startsWith('https://operationtoneup.com') && window.history ) {
                    console.log('Page Navigation: Reset -> automated window.history.back() !guest and otu site or fundraiser based.');
                    window.history.back()
                    return true
                }

                defaultUrl=otuApp.appState.rootUrl  + 'index.php?option=com_otu_op&task=goToStep&step=0';
                otuApp.triggerAjaxGet(defaultUrl,
                    {"attr":{"data-hide-template-position":"columns-all"}});	
            }
        }

    }
    return otuApp.pageNavigation;
}

function history(Options={}) {
    var options = {
        toneUpTalk: false
    };
    $.extend(options,Options);

    if (options.toneUpTalk) {
        return _toneUpTalkHistory;
    } else {
        return _taskHistory;
}}

function setHistory( Options={} ) {
    var options = {
        history: false
    };
    $.extend(options,Options)

    _taskHistory = options.history
}

function route( options={} ) {
    console.log('Page Navigation - Route ',options )
    var rootUrl = null
    var _lang = otuApp.appState.language


    if ( otuApp.isCordovaApp() ) {
        try {      
        rootUrl = new URL ( frameWork.options.KIUrl );
            _lang = myApp.settings['language']
        } catch (err) {
            console.error(err)
        }
    } else {
        try {
            rootUrl = new URL ( otuApp.appState.rootUrl );
        } catch (err) {
            console.error(err)
        }
    }
    
    if (! rootUrl instanceof URL ) { 
        console.notice('Page Navigation - No rootUrl set');
        return url;
    }
    
    var { url = null, lang = _lang } = options  ;

    if ( url.startsWith('/') ) {
        url = rootUrl.origin + url;
    }

    const newUrl = new URL( url );

    // we only want to route internal urls, not libs or images
    const fileExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'svg','js'];
    const regex = new RegExp(`\\.(${fileExtensions.join('|')})(\\?.*)?$`, 'i');
    
    if ( url.indexOf(rootUrl.toString()) >=0 && !regex.test(url.toString())) {

        // yeah should not hard code this but I got a sneezing cold
        if ( !( url.indexOf(rootUrl.toString() + 'es/' ) >=0 
                || url.indexOf(rootUrl.toString() + 'en/' ) >=0) 
                    &&	!url.indexOf('lang=')>=0) {
            
                        //url = url + '&lang=' + otuApp.appState.languageSef;
                        switch ( lang ) {

                            case 'es-ES':
                                otuApp.appState.languageSef='es';
                                break;
                            case 'en-GB':
                            default:
                                otuApp.appState.languageSef='en';
                                break;
                        }

                        if ( true || otuApp.appState.languageSef!='en') {
                            console.log('Language - Adding tag to ', url.toString());

                            newUrl.pathname = newUrl.pathname.replace( rootUrl.pathname, rootUrl.pathname + otuApp.appState.languageSef + '/' );
                            newUrl.pathname = newUrl.pathname.replace( 'index.php','');

                            console.log('Language - New Url', newUrl.toString());
                            url = newUrl.toString();
                        }
        }


        if ( lang ) { 

            // force a language change
            var languageSef = null;

            switch ( lang ) {
                case 'es-ES':
                    languageSef='es';
                    break;
                case 'en-GB':
                default:
                    languageSef='en';
                    break;
            }

            if ( newUrl.searchParams.get('lang') && lang!=newUrl.searchParams.get('lang') ) {

                newUrl.searchParams.set('lang',languageSef )
                url = newUrl.toString()

            }

            url = url.replace(rootUrl.toString() + 'es/', rootUrl.toString() + languageSef + '/')
            url = url.replace(rootUrl.toString() + 'en/', rootUrl.toString() + languageSef + '/')

            console.log('Language - New Url forced ',lang, url )

        }

    } else {
        console.log('Page Navigation - Not routing not in internal url',url, rootUrl)
    }

    return url;

}

function updateLanguage( options = {} ) {
    console.log('Language - Update Language',options )
    const { lang = 'en-GB' } = options

    _taskHistory.forEach( function ( h ) {
        h.url = route( { url : h.url, lang} )
    })

}

otuApp.pageNavigation = {
    add,restoreTask,reset, history, setHistory, reloadLast, refreshAppState, route, updateLanguage
}

const getHostname = (url) => {
    // use URL constructor and return hostname
    let Url = new URL(otuApp.appState.rootUrl);
    return Url.protocol + '//' + Url.hostname;
  }